import classNames from "classnames";

export const NotFound = () => {
    return (
        <div className={classNames("page-body", "ctr-v-h")}>
            <h1>Error 404</h1>
            <p className="err-text">Page not found</p>
        </div>
    )
}